import { TemplateParams } from '../../schema/message/template-schema';
import {
  AudioFileExtensions,
  ImageFileExtensions,
  VideoFileExtensions,
} from '../../schema/message/enum';
import {
  Media,
  MsgTemplate,
  TemplateComponents,
} from '../../schema/message/inferface';

type MediaType = 'image' | 'audio' | 'video' | 'document';

const resolveMediaType = (cntType?: string): MediaType => {
  if (!cntType) return 'document';

  const value = cntType.toLowerCase();

  if (value.includes('image') || ImageFileExtensions.includes(value))
    return 'image';

  if (value.includes('audio') || AudioFileExtensions.includes(value))
    return 'audio';

  if (value.includes('video') || VideoFileExtensions.includes(value))
    return 'video';

  return 'document';
};

const headerFormatMap: Record<
  MediaType,
  'IMAGE' | 'AUDIO' | 'VIDEO' | 'DOCUMENT'
> = {
  image: 'IMAGE',
  audio: 'AUDIO',
  video: 'VIDEO',
  document: 'DOCUMENT',
};

export const getMediaTemplateFromObject = (
  media: Media[],
  text: string,
  fileUrl?: string
): MsgTemplate => {
  if (!media?.length && fileUrl) {
    return {
      media: {
        components: [
          { type: 'HEADER', format: 'DOCUMENT' },
          { type: 'BODY', text },
        ],
        params: [
          {
            type: 'header',
            parameters: [{ type: 'document', document: { link: fileUrl } }],
          },
        ],
      },
    };
  }

  const mediaParams: TemplateParams = media.map(
    ({ cUrl, path, cntType, name }) => {
      const type = resolveMediaType(cntType);
      const link = path || cUrl || fileUrl;
      return {
        type: 'header',
        parameters: [{ type, [type]: { link, filename: name } }],
      };
    }
  );

  const mediaComponents: TemplateComponents = media.map(({ cntType }) => {
    const type = resolveMediaType(cntType);
    return { type: 'HEADER', format: headerFormatMap[type] };
  });

  const caption =
    media.find(({ caption }) => Boolean(caption))?.caption || text;

  return {
    media: {
      params: mediaParams,
      components: [...mediaComponents, { type: 'BODY', text: caption }],
    },
  };
};
